// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_thread_column/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_thread_column: ModuleSchema = {
  "id": "core_thread_column",
  "uniqueId": "B3D_2T9VK",
  "createdAt": "2026-09-30T15:26:00Z",
  "updatedAt": "2026-10-28T14:58:33.335Z",
  "label": "Thread Column",
  "description": "Trapezoidal Thread Column built from the CG_2T9VK core primitive",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_2T9VK"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Width / Diameter",
      "min": 20,
      "max": 150,
      "default": 60,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "height",
      "label": "Height / Length",
      "min": 10,
      "max": 100,
      "default": 25,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "threadPitch",
      "label": "Thread Pitch",
      "min": 1.5,
      "max": 6,
      "default": 3,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "body",
      "label": "Body Color",
      "default": "#0284c7",
      "enabled": true,
      "visible": true,
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "main_body",
      "name": "Trapezoidal Thread Column",
      "parts": [
        {
          "id": "body_shell",
          "name": "Trapezoidal Thread Column",
          "label": "Trapezoidal Thread Column",
          "groupId": 0,
          "previewQuality": "medium",
          "exportQuality": "high"
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    }
  ]
};
